import React from 'react';
import { getBannerHeight, getBannerMaxHeight, isImageWide } from '../../utils';
export const Skeleton = ({ imageSize }) => {
    let ratioStyles;
    if (isImageWide(imageSize)) {
        ratioStyles = {
            paddingTop: getBannerHeight({ imageSize, unit: '%' }),
        };
    }
    else {
        ratioStyles = {
            height: getBannerHeight({ imageSize }),
            maxHeight: getBannerMaxHeight({ imageSize }),
            flex: '0 0 auto',
        };
    }
    return (React.createElement("div", { style: {
            width: '100%',
            background: 'linear-gradient(-33deg, #fff 50%, #d7e3ff 0)',
            ...ratioStyles,
        } }));
};
